// extracted by mini-css-extract-plugin
module.exports = {"container":"socials_container__A6ypd","itemsContainer":"socials_itemsContainer__hAioV"};